<!--
 * @Description: 协议列表
 * @Author: maben
 * @Date: 2025-09-18 14:46:45
 * @LastEditors: maben
-->
<template>
    <div>
        <comp-title-dc back-url-name="acctManager" :back-url-query="{ activeIndex: '6-1' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager?activeIndex=6-1' }">
                    协议/合同列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>合同列表</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-change-card-list">
            <div class="header-title">
                <div>电子合同查询</div>
                <div class="fund-search">
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入基金代码/名称查询"
                        class="input-search"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                        <el-button
                            slot="suffix"
                            icon="el-icon-search"
                            class="search-icon"
                            type="text"
                            size="small"
                            v-on:click="getContractList()"
                        />
                    </el-autocomplete>

                    <date-picker
                        :date="dateSet"
                        sep-text="-"
                        class="input-date"
                        clearable
                        v-on:date-get="dateInterval"
                    />

                    <el-button
                        class="el-button--red"
                        size="small"
                        :disabled="isLoading"
                        v-on:click="getContractList()"
                    >
                        查询
                    </el-button>
                </div>
            </div>
            <el-table :data="dataList" class="tab-list-tit table-list">
                <el-table-column prop="fundcode" label="产品名称" width="200">
                    <template slot-scope="scope">
                        <div>{{ scope.row.fundname }}</div>
                        <div>{{ scope.row.fundcode }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="contractsno" label="申请编号" align="center" />
                <el-table-column prop="transactiondate" label="申请日期" align="center">
                    <template slot-scope="scope">
                        <div>{{ $util.fmtDate(scope.row.transactiondate) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="custname" label="客户姓名" align="center" />
                <el-table-column prop="contractno" label="合同编号" align="center" />
                <el-table-column prop="filetype" label="合同类型" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ transText(scope.row.contracttype) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="filename" label="合同名称" align="center" />
                <el-table-column prop="signdate" label="合同签署时间" align="center">
                    <template slot-scope="scope">
                        <div>{{ $util.fmtDate(scope.row.signdate) }}</div>
                        <div>{{ $util.fmtTime(scope.row.signtime) }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number($util.getConfig().const.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker";
export default {
    name: "ContractList",
    components: {
        datePicker
    },
    mixins: [mixin],
    data() {
        return {
            // 入参
            dateSet: {
                type: "2",
                min: "1990-01-01",
                size: "medium",
                text: "开始时间",
                text2: "结束时间"
            },
            isLoading: false,
            endDate: "",
            beginDate: "",
            nowDate: "",
            searchText: "", // 搜索文本填充内容
            dataList: [],
            curPage: 1,
            allPage: 0,
            queryFind: null // 定时器
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchFund();
            }
        }
    },
    created() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.getContractList();
    },
    methods: {
        // 获取用户选中时间区间
        dateInterval(val) {
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        async getContractList(val = 1) {
            this.isLoading = false;
            const res = await fundApi.queryCustAcctElecontractFile({
                fundcode: this.searchText,
                statusstr: "00,01,02,05,08,09", // 只查有效的,后端接口没办法吧这个状态字段写死
                begindate: this.beginDate,
                enddate: this.endDate,
                filetype: "0",
                pageSize: this.$util.getConfig().const.PAGE_SIZE,
                pageNum: val
            });
            if (res.data) {
                this.allPage = res.data.total;
                this.dataList = res.data.data ? res.data.data : [];
            }
            this.isLoading = false;
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(
                    this.searchText.indexOf("(") + 1,
                    this.searchText.indexOf(")")
                );
            }
            this.pageoffset = 1;
            this.getContractList();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const exType = ["999", "0", "zghr", "hot"];
            const _x = {
                fundshowtype: "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: 20,
                pagenum: 1,
                tradingmethod: this.$util.getConfig().systemtype,
                orderfield: "thisyear1ud",
                isasc: 0,
                fundclass: "1"
            };
            const res = await fundApi.getFundLists(_x);
            if (res.data) {
                if (cb) {
                    cb.call(_this, res.data.list);
                }
            }
        },
        dataReset(val) {
            this.getContractList(val);
        },
        transText(val) {
            if (val == "1") {
                return "电子";
            } else if (val == "2") {
                return "纸质";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-change-card-list {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-bottom: 52px;

    .header-title {
        width: 1160px;
        height: 60px;
        margin-left: 20px;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .input-search {
        width: 260px;
        vertical-align: middle;
        .search-icon {
            margin: 0 5px;
            height: 40px;
            color: #666666;
        }

        .el-input__inner {
            height: 40px;
            line-height: 40px;
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
        }
    }

    .input-date {
        width: 480px;
        margin-left: 10px;
    }

    .table-list {
        width: 1160px;
        margin: auto;
        margin-top: 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
    }

    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
}
</style>
